module.exports = __webpack_public_path__ + "static/media/logo.4d5e1509.svg";